import superMeta from '../_COMMON/metaCommonNode.mjs'

export default {
    ...superMeta,
    classes: ['comment', ...superMeta.classes],
}
